import * as React from "react";
import MUIDataTableLib, { MUIDataTableColumn } from "mui-datatables";
// Rolldown (Vite 8) doesn't recognize exports.default on CJS modules without __esModule:true,
// so the default import arrives as the full module namespace object. Access .default explicitly.
const MUIDataTable = ((MUIDataTableLib as any).default ?? MUIDataTableLib) as typeof MUIDataTableLib;

interface IMUIDataTableDesktopProps {
  title: string;
  columns: unknown[];
  data: unknown[];
  options: unknown;
  onRowClick?: (data: unknown, tableMeta?: unknown) => void;
}

const MUIDataTableDesktop: React.FunctionComponent<IMUIDataTableDesktopProps> = (
  props
) => {
  return (
    <MUIDataTable
      title={props.title}
      columns={props.columns as MUIDataTableColumn[]}
      data={props.data as object[]}
      options={{ ...(props.options as object), onRowClick: props.onRowClick }}
    />
  );
};

export default MUIDataTableDesktop;
